import {
  ABOUT_PAGE_URL,
  CONTACT_PAGE_URL,
  HOME_PAGE_URL,
} from '../constants/Routes';

export const FooterLinksArray = [
  {
    name: 'Home',
    route: HOME_PAGE_URL,
  },
  {
    name: 'About',
    route: ABOUT_PAGE_URL,
  },
  //   {
  //     name: 'Sessions',
  //     route: SESSIONS_PAGE_URL,
  //   },
  //   {
  //     name: 'Fansites',
  //     route: CLIPS_FANSITES_PAGE_URL,
  //   },
  {
    name: 'Contact',
    route: CONTACT_PAGE_URL,
  },
];
